import {Localizer} from "../../../infrastructure/localization/localizer";
import {useState} from "react";
import {ForloebOverviewFilterModel, toState} from "./ForloebOverviewFilterModel";
import {setSlideinState, SlideInStateEnum} from "../slideIn/slideInSlice";
import {useAppDispatch} from "../../../app/hooks";
import {applyFilters} from "./forloebOverviewFiltersSlice";
import {ValidationForm} from "../validation/components/validationForm";
import {BuildNew, CreateFilterInputModel, CreateFilterValidationSchema} from "../filter/createFilterInputModel";
import {NotificationModule} from "ditmer-embla";
import {CrudFilterInputModel} from "./crudFilterInputModel";
import {ValidationFormSubmitButton} from "../validation/components/validationFormButton";
import {HandleError} from "../../infrastructure/errors/errorBoundary";
import { ForloebOverviewCreateFilterProps } from "./forloebOverviewFilterProps";
import {ModalAcceptType} from "../modalMessage/modalSubmitMessage";
import {FilterValidationInput} from "../filter/filterValidationInput";
import useLogbogApi from "core/hooks/useLogbogApi";

export function ForloebOverviewCreateFilter({
    filter,
    filterAppliedCallback,
    modalId,
    paginationModel,
    permissions
}: ForloebOverviewCreateFilterProps) {
    
    const dispatch = useAppDispatch();
    const { logbogFilterApi } = useLogbogApi();

    const [filterModel, setFilterModel] = useState<ForloebOverviewFilterModel>(filter);
    
    const setForloebOverviewFilters = async () => {
        dispatch(setSlideinState({state: SlideInStateEnum.ActionOngoing, slideInId: modalId}))

        const filterToApply = {
            ...filterModel,
            titel: Localizer.forloebOverviewPage_anvendFilter()
        } as ForloebOverviewFilterModel

        dispatch(applyFilters(toState(filterToApply)))
        filterAppliedCallback(filterToApply);

        NotificationModule.showSuccess(Localizer.forloebOverviewPage_filterApplied(), "");
        dispatch(setSlideinState({state: SlideInStateEnum.Closing, slideInId: modalId}))
    }

    const CreateForloebOverviewFilter = async (inputModel: CreateFilterInputModel) => {
        dispatch(setSlideinState({state: SlideInStateEnum.ActionOngoing, slideInId: modalId}));

        const filterToCreate = {
            ...filterModel,
            regioner: filterModel.regioner?.filter(r => r !== Localizer.global_all()),
            titel: inputModel.titel,
            regionRettigheder: inputModel.regionRettigheder,
        } as ForloebOverviewFilterModel

        const createdFilterId = await logbogFilterApi.createForloebOverblikFilter(filterToCreate);

        if (!createdFilterId) {
            return;
        }

        const createdFilter = {
            ...filterToCreate,
            filterId: createdFilterId
        } as ForloebOverviewFilterModel

        dispatch(applyFilters(toState(createdFilter)))
        filterAppliedCallback(createdFilter);

        NotificationModule.showSuccess(Localizer.forloebOverviewPage_filterApplied(), "");
        dispatch(setSlideinState({state: SlideInStateEnum.Closing, slideInId: modalId}));
    };

    return (
        <div className="row">
            <div className="col-sm-12 flex-container-column">
                <ValidationForm
                    key={modalId}
                    initialValues={BuildNew()}
                    validationSchema={CreateFilterValidationSchema}
                    onSubmit={
                        async (values) => {
                            await CreateForloebOverviewFilter(values).catch(err => { // catch is needed to handle unhandeled exception (eg. api offline). Formik onsubmithandler is catching all exception and writing them as warnings
                                dispatch(setSlideinState({state: SlideInStateEnum.Opened, slideInId: modalId}))
                                HandleError(err);
                            });
                        }}>
                    {
                        (formik) => (
                            <>
                                <CrudFilterInputModel onChangeCallback={setFilterModel} filter={filter} modalId={modalId} permissions={permissions}/>
                                <div className="margin-top-m">
                                    <h5 className="subtle">
                                        {Localizer.forloebOverviewPage_gemFilter()}
                                    </h5>

                                    <FilterValidationInput
                                        modalId={modalId}
                                        formik={formik}
                                    />

                                    <div className="margin-bottom-m float-right">
                                        <ValidationFormSubmitButton formikProps={formik} buttonType={ModalAcceptType.default}>
                                            {Localizer.forloebOverviewPage_opretFilter()}
                                        </ValidationFormSubmitButton>
                                    </div>
                                </div>
                            </>
                        )
                    }
                </ValidationForm>

                <div className="modal-actions">
                    <button className="btn btn-primary margin-right-m" onClick={() => setForloebOverviewFilters()}>
                        {Localizer.forloebOverviewPage_anvendFilter()}
                    </button>
                </div>
            </div>
        </div>
    );
}
